<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: cw.CwCaseTypeStep object component — step base data (data widget + edit toggle) plus the
    three step-bound configuration tables. Guarded by @if (initialized && dto); renders vertically
    stacked so it fits the right drawer (uiMode 'side') and full mode alike.
-->
@if (initialized && dto) {
    <div class="cw-step-object flex flex-column gap-4 p-3">

        <!-- Step base data -->
        <div>
            <div class="flex align-items-center justify-content-between mb-2">
                <span class="text-lg font-medium">Schritt-Stammdaten</span>
                <p-button
                    [label]="editStep ? 'Ansicht' : 'Bearbeiten'"
                    [icon]="editStep ? 'fa-regular fa-eye' : 'fa-regular fa-pen'"
                    severity="secondary"
                    [text]="true"
                    (onClick)="toggleEditStep()">
                </p-button>
            </div>
            @if (!editStep && stepDataWidget) {
                <mvs-widget [widgetData]="stepDataWidget"></mvs-widget>
            }
            @if (editStep && stepEditWidget) {
                <mvs-widget [widgetData]="stepEditWidget"></mvs-widget>
            }
        </div>

        <!-- Freigaben -->
        <div>
            <span class="text-lg font-medium block mb-2">Freigaben</span>
            @if (approvalWidget) {
                <mvs-widget [widgetData]="approvalWidget"></mvs-widget>
            }
        </div>

        <!-- Geschäftsprüfungen -->
        <div>
            <span class="text-lg font-medium block mb-2">Geschäftsprüfungen</span>
            @if (businessCheckWidget) {
                <mvs-widget [widgetData]="businessCheckWidget"></mvs-widget>
            }
        </div>

        <!-- Produkt-Geschäftsprüfungen -->
        <div>
            <span class="text-lg font-medium block mb-2">Produkt-Geschäftsprüfungen</span>
            @if (productBusinessCheckWidget) {
                <mvs-widget [widgetData]="productBusinessCheckWidget"></mvs-widget>
            }
        </div>

    </div>
}
